import { render, staticRenderFns } from "./CreateTermicCourse.vue?vue&type=template&id=55aeaf02&scoped=true"
import script from "./CreateTermicCourse.vue?vue&type=script&lang=js"
export * from "./CreateTermicCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateTermicCourse.vue?vue&type=style&index=0&id=55aeaf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aeaf02",
  null
  
)

export default component.exports